import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

export default function OfflineBanner({ onRetry }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: 'linear-gradient(135deg, #b71c1c, #d32f2f)',
      color: 'white',
      padding: '12px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      fontSize: 14,
      fontWeight: 500,
      boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
      animation: 'slideDown 0.3s ease',
    }}>
      <WifiOff size={18} />
      <span>You are offline. Some features may not work.</span>
      <button 
        onClick={onRetry}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          color: 'white',
          padding: '6px 14px',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 13,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <RefreshCw size={14} /> Retry
      </button>
    </div>
  );
}